"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const text_1 = require("../text");
const PasswordInput = props => {
    const [show, setShow] = (0, react_1.useState)(false);
    const inputRef = (0, react_1.useRef)(null);
    const handleClick = () => {
        const input = inputRef.current;
        if (input) {
            const start = input.selectionStart;
            const end = input.selectionEnd;
            setShow(prev => !prev);
            setTimeout(() => {
                input.setSelectionRange(start, end);
            }, 0);
        }
        else {
            setShow(prev => !prev);
        }
    };
    return ((0, jsx_runtime_1.jsx)(text_1.TextInput, { sx: {
            my: 1,
            "& input::-ms-reveal": { display: "none" },
            "& input::-ms-clear": { display: "none" },
        }, type: show ? "text" : "password", InputProps: {
            endAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onMouseDown: e => e.preventDefault(), onClick: handleClick, children: show ? (0, jsx_runtime_1.jsx)(icons_material_1.Visibility, {}) : (0, jsx_runtime_1.jsx)(icons_material_1.VisibilityOff, {}) }) })),
            inputRef,
        }, ...props }));
};
exports.PasswordInput = PasswordInput;
//# sourceMappingURL=index.js.map